var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.514 5.133 8.048 3.6V10c0 .4.266.667.666.667s.667-.267.667-.667V3.6l1.533 1.533a.644.644 0 0 0 .934 0 .644.644 0 0 0 0-.933L9.18 1.533c-.067-.066-.133-.133-.2-.133-.133-.067-.333-.067-.533 0-.067 0-.134.067-.2.133L5.58 4.2a.644.644 0 0 0 0 .933.644.644 0 0 0 .933 0m8.2 4.2c-.4 0-.666.267-.666.667v2.667c0 .4-.267.666-.667.666H4.048c-.4 0-.667-.266-.667-.666V10c0-.4-.267-.667-.667-.667s-.666.267-.666.667v2.667c0 1.133.866 2 2 2h9.333c1.133 0 2-.867 2-2V10c0-.4-.267-.667-.667-.667"
  })));
};
export default SvgExport;